<div class="card">
  <div class="card-header d-md-block d-none">
    <app-page-title [breadcrumbItems]="breadCrumbItems"/>
  </div>
  <div class="d-flex flex-wrap justify-content-between align-items-center py-2 px-1">
    <div class="p-2">
      <h1 class="fs-20 p-0 m-0 text-dark-emphasis fw-bolder">{{ 'MANAGE_USER_TENANT'|translate }}</h1>
    </div>
<!--    <button (click)="onAdd()" class="p-2 text-light bg-primary d-flex align-items-center gap-2 rounded-3"-->
<!--            style="border: none">-->
<!--      <i class="ri-add-circle-line fs-18"></i>-->
<!--      <span class="fw-bolder">{{ 'CREATE_USER_TENANT'|translate }}</span>-->
<!--    </button>-->
  </div>
  <p-table
    [hasList]="service.hasList"
    (add)="onAdd()"
    (delete)="onDelete($event)"
    (edit)="onEdit($event)"
    (onLazyLoad)="loadData($event)"
    (onPage)="pageChange($event)"
    (view)="onView($event)"
    [columns]="service.tableColumns"
    [dataKey]="'id'"
    [first]="first"
    [globalSearch]="globalSearch"
    [hasActions]="service.hasActions"
    [hasAdd]="service.hasAdd"
    [hasDelete]="service.hasDelete"
    [hasEdit]="service.hasEdit"
    [hasView]="service.hasView"
    [loading]="loading()"
    [rows]="rows"
    [scrollHeight]="'calc(111vh - 420px)'"
    [selectionMode]="'single'"
    [title]="service.title"
    [totalRecords]="total"
    [value]="list"
    paginatorPosition="bottom"
    tableStyleClass="table table-hover"
  >
    <ng-template #cells let-data>
      @for (col of service.tableColumns; track col) {
        <td>
          <span class="p-datatable-column-title">
                    @if (col.iconClass) {
                      <i [class]="col.iconClass"></i>
                    }
            {{ (col.label ?? col.fieldName) | translate }}
          </span>
          @switch (col.fieldName) {
            @case ('actions') {
              <a [routerLink]="[Resources.RentersDetails | resourceById:data.id]" class="btn-outline-primary">
                {{ 'INVOICES.DETAILS' | translate }}
              </a>
            }
            @case ('clientType') {
              {{ data.clientType ? (ClientTypesLabels[data.clientType] | translate) : '-' }}
            }
            @default {
              <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
            }
          }
        </td>
      }
    </ng-template>
  </p-table>
</div>


